import React, { useState, useEffect } from "react";
import axios from "../api/axios";
import {
  FiUsers, FiSearch, FiLoader, FiChevronDown, FiChevronUp,
  FiCheck, FiX, FiCalendar, FiPhone, FiMail
} from "react-icons/fi";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800;900&display=swap');

  .dt-root {
    font-family: 'Montserrat', sans-serif;
    padding: 24px;
    max-width: 80rem;
    margin: 0 auto;
    min-height: 100vh;
    background: linear-gradient(135deg, #f1f5f9 0%, #eff6ff 50%, #f1f5f9 100%);
  }

  @media (max-width: 640px) {
    .dt-root {
      padding: 16px;
    }
  }

  /* Header */
  .dt-header {
    margin-bottom: 32px;
  }

  .dt-title {
    font-size: 28px;
    font-weight: 700;
    background: linear-gradient(135deg, #1e293b, #475569);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin-bottom: 8px;
  }

  @media (min-width: 640px) {
    .dt-title {
      font-size: 30px;
    }
  }

  .dt-subtitle {
    color: #6b7280;
  }

  /* Summary Cards */
  .dt-summary-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
    margin-bottom: 32px;
  }

  @media (min-width: 768px) {
    .dt-summary-grid {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  .dt-summary-card {
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    padding: 24px;
    border-left: 4px solid;
  }

  .dt-summary-card-blue {
    border-left-color: #3b82f6;
  }

  .dt-summary-card-green {
    border-left-color: #22c55e;
  }

  .dt-summary-card-purple {
    border-left-color: #8b5cf6;
  }

  .dt-summary-card-orange {
    border-left-color: #f59e0b;
  }

  .dt-summary-label {
    font-size: 14px;
    color: #6b7280;
    margin-bottom: 4px;
  }

  .dt-summary-value {
    font-size: 28px;
    font-weight: 700;
    color: #1f2937;
  }

  /* Search */
  .dt-search-wrap {
    margin-bottom: 24px;
    position: relative;
  }

  .dt-search-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #9ca3af;
  }

  .dt-search-input {
    width: 100%;
    padding: 12px 16px 12px 40px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    font-size: 14px;
    font-family: 'Montserrat', sans-serif;
    outline: none;
    transition: all 0.2s;
  }

  .dt-search-input:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
  }

  /* Table */
  .dt-table-wrap {
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    overflow: hidden;
  }

  .dt-table-scroll {
    overflow-x: auto;
  }

  .dt-table {
    width: 100%;
    border-collapse: collapse;
  }

  .dt-table-head {
    background: #f9fafb;
  }

  .dt-table-head th {
    padding: 12px 24px;
    text-align: left;
    font-size: 12px;
    font-weight: 500;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  .dt-table-body {
    border-top: 1px solid #e5e7eb;
  }

  .dt-table-body tr {
    border-bottom: 1px solid #e5e7eb;
    transition: background 0.2s;
  }

  .dt-table-body tr:hover {
    background: #f9fafb;
  }

  .dt-table-body td {
    padding: 16px 24px;
  }

  .dt-empty-row td {
    padding: 48px 24px;
    text-align: center;
    color: #6b7280;
  }

  /* Member Info */
  .dt-member {
    display: flex;
    align-items: center;
  }

  .dt-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: linear-gradient(135deg, #3b82f6, #8b5cf6);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-weight: 700;
    font-size: 16px;
    margin-right: 12px;
    flex-shrink: 0;
  }

  .dt-member-name {
    font-weight: 500;
    color: #1f2937;
  }

  /* Status Badges */
  .dt-badge {
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    border-radius: 9999px;
    font-size: 12px;
    font-weight: 500;
  }

  .dt-badge-active {
    background: #d1fae5;
    color: #065f46;
  }

  .dt-badge-inactive {
    background: #fee2e2;
    color: #991b1b;
  }

  .dt-badge-icon {
    margin-right: 4px;
  }

  /* Program Badges */
  .dt-program-badge {
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    border-radius: 9999px;
    font-size: 12px;
    font-weight: 500;
    margin-right: 4px;
  }

  .dt-program-lbbp {
    background: #ede9fe;
    color: #5b21b6;
  }

  .dt-program-puap {
    background: #d1fae5;
    color: #065f46;
  }

  .dt-program-group {
    display: flex;
    gap: 4px;
    flex-wrap: wrap;
  }

  /* Expand Button */
  .dt-expand-btn {
    background: none;
    border: none;
    color: #3b82f6;
    cursor: pointer;
    padding: 4px;
    transition: color 0.2s;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .dt-expand-btn:hover {
    color: #1d4ed8;
  }

  /* Expanded Row */
  .dt-expanded {
    background: #f9fafb;
  }

  .dt-expanded-cell {
    padding: 16px 24px;
  }

  .dt-expanded-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
  }

  @media (min-width: 768px) {
    .dt-expanded-grid {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  .dt-expanded-item {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #6b7280;
  }

  .dt-expanded-item svg {
    margin-right: 8px;
    flex-shrink: 0;
  }

  /* Loading State */
  .dt-loading {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #f1f5f9 0%, #eff6ff 50%, #f1f5f9 100%);
  }

  .dt-loading-content {
    text-align: center;
  }

  .dt-spinner {
    animation: dt-spin 1s linear infinite;
    font-size: 36px;
    color: #3b82f6;
    margin: 0 auto 16px;
    display: block;
  }

  @keyframes dt-spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }

  .dt-loading-text {
    color: #6b7280;
  }

  /* Error State */
  .dt-error {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #f1f5f9 0%, #eff6ff 50%, #f1f5f9 100%);
  }

  .dt-error-content {
    text-align: center;
    color: #ef4444;
  }

  .dt-error-text {
    margin-bottom: 16px;
  }

  .dt-retry-btn {
    padding: 8px 16px;
    background: #3b82f6;
    color: #ffffff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    transition: background 0.2s;
  }

  .dt-retry-btn:hover {
    background: #2563eb;
  }

  /* Responsive */
  @media (max-width: 640px) {
    .dt-table-body td {
      padding: 12px 16px;
    }

    .dt-table-head th {
      padding: 10px 16px;
      font-size: 10px;
    }

    .dt-avatar {
      width: 32px;
      height: 32px;
      font-size: 12px;
      margin-right: 8px;
    }

    .dt-summary-value {
      font-size: 22px;
    }

    .dt-expanded-grid {
      grid-template-columns: 1fr;
    }
  }
`;

const DirectTeam = ({ user }) => {
  const [members, setMembers] = useState([]);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [expandedRows, setExpandedRows] = useState(new Set());

  useEffect(() => {
    fetchDirectTeam();
  }, []);

  const fetchDirectTeam = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get("/puap/direct-team");
      setMembers(data.members);
      setSummary(data.summary);
    } catch (err) {
      setError(err.response?.data?.error || "Failed to load direct team");
    } finally {
      setLoading(false);
    }
  };

  const toggleRow = (id) => {
    const set = new Set(expandedRows);
    set.has(id) ? set.delete(id) : set.add(id);
    setExpandedRows(set);
  };

  const filteredMembers = members.filter(m => {
    const q = searchTerm.toLowerCase();
    return (
      (m.name?.toLowerCase() || "").includes(q) ||
      (m.uniqueId?.toLowerCase() || "").includes(q) ||
      (m.mobile?.toLowerCase() || "").includes(q) ||
      (m.email?.toLowerCase() || "").includes(q)
    );
  });

  if (loading) {
    return (
      <div className="dt-loading">
        <style>{styles}</style>
        <div className="dt-loading-content">
          <FiLoader className="dt-spinner" />
          <p className="dt-loading-text">Loading direct team...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="dt-error">
        <style>{styles}</style>
        <div className="dt-error-content">
          <p className="dt-error-text">{error}</p>
          <button onClick={fetchDirectTeam} className="dt-retry-btn">
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="dt-root">
      <style>{styles}</style>

      <div className="dt-header">
        <h1 className="dt-title">Direct Team</h1>
        <p className="dt-subtitle">View your direct referrals and their status</p>
      </div>

      {summary && (
        <div className="dt-summary-grid">
          <div className="dt-summary-card dt-summary-card-blue">
            <div className="dt-summary-label">Total Members</div>
            <div className="dt-summary-value">{summary.totalMembers}</div>
          </div>
          <div className="dt-summary-card dt-summary-card-green">
            <div className="dt-summary-label">Active Members</div>
            <div className="dt-summary-value">{summary.activeMembers}</div>
          </div>
          <div className="dt-summary-card dt-summary-card-purple">
            <div className="dt-summary-label">PU&AP Active</div>
            <div className="dt-summary-value">{summary.puapActiveMembers}</div>
          </div>
          <div className="dt-summary-card dt-summary-card-orange">
            <div className="dt-summary-label">LBBP Active</div>
            <div className="dt-summary-value">{summary.lbbpActiveMembers}</div>
          </div>
        </div>
      )}

      <div className="dt-search-wrap">
        <FiSearch className="dt-search-icon" />
        <input
          type="text"
          placeholder="Search by name, ID, phone, or email..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="dt-search-input"
        />
      </div>

      <div className="dt-table-wrap">
        <div className="dt-table-scroll">
          <table className="dt-table">
            <thead className="dt-table-head">
              <tr>
                <th>Member</th>
                <th>ID</th>
                <th>Status</th>
                <th>Programs</th>
                <th>Join Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody className="dt-table-body">
              {filteredMembers.length === 0 ? (
                <tr>
                  <td colSpan="6" className="dt-empty-row">
                    No direct members found
                  </td>
                </tr>
              ) : (
                filteredMembers.map((member) => (
                  <React.Fragment key={member._id}>
                    <tr>
                      <td>
                        <div className="dt-member">
                          <div className="dt-avatar">
                            {member.name?.charAt(0).toUpperCase() || "U"}
                          </div>
                          <div className="dt-member-name">{member.name}</div>
                        </div>
                      </td>
                      <td>
                        <div style={{ fontSize: '14px', color: '#1f2937' }}>{member.uniqueId}</div>
                      </td>
                      <td>
                        {member.isActive ? (
                          <span className="dt-badge dt-badge-active">
                            <FiCheck className="dt-badge-icon" size={12} /> Active
                          </span>
                        ) : (
                          <span className="dt-badge dt-badge-inactive">
                            <FiX className="dt-badge-icon" size={12} /> Inactive
                          </span>
                        )}
                      </td>
                      <td>
                        <div className="dt-program-group">
                          {member.isShareActive && (
                            <span className="dt-program-badge dt-program-lbbp">LBBP</span>
                          )}
                          {member.isProductActive && (
                            <span className="dt-program-badge dt-program-puap">PU&AP</span>
                          )}
                        </div>
                      </td>
                      <td>
                        <div style={{ fontSize: '14px', color: '#1f2937' }}>
                          {member.joinDate ? new Date(member.joinDate).toLocaleDateString() : "N/A"}
                        </div>
                      </td>
                      <td>
                        <button
                          onClick={() => toggleRow(member._id)}
                          className="dt-expand-btn"
                        >
                          {expandedRows.has(member._id) ? (
                            <FiChevronUp size={20} />
                          ) : (
                            <FiChevronDown size={20} />
                          )}
                        </button>
                      </td>
                    </tr>
                    {expandedRows.has(member._id) && (
                      <tr className="dt-expanded">
                        <td colSpan="6" className="dt-expanded-cell">
                          <div className="dt-expanded-grid">
                            {member.mobile && (
                              <div className="dt-expanded-item">
                                <FiPhone />
                                {member.mobile}
                              </div>
                            )}
                            {member.email && (
                              <div className="dt-expanded-item">
                                <FiMail />
                                {member.email}
                              </div>
                            )}
                            {member.sponsorName && (
                              <div className="dt-expanded-item">
                                <FiUsers />
                                Sponsor: {member.sponsorName} ({member.sponsorUniqueId})
                              </div>
                            )}
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default DirectTeam;